import React, { Component } from 'react';
import { Header } from '../components/Header';
import { EvaSchiffererFooter } from '../components/EvaSchiffererFooter';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronsDownIcon } from 'lucide-react';
export function EvaSchiffererPsychotherapiePage() {
  return <div className="min-h-screen bg-white" data-id="element-1890">
      <Header data-id="element-1891" />
      {/* Hero Section mit Bild und Überschrift */}
      <section className="w-full mt-[152px] flex justify-center" data-id="element-1892">
        <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-1893">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9KbSr3FchmVKf9er8q3k2J/Header-Psychotherapie-Eva_Schifferer.jpg" alt="Psychotherapie Header Bild" className="w-full h-full object-cover" data-id="element-1894" />
          <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-1895"></div>
          <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-1896">
            <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-1897">
              <div className="max-w-lg text-left" data-id="element-1898">
                <p className="text-white text-2xl md:text-3xl font-light mb-4" data-id="element-1899">
                  Krisen sind kräftezehrend – müssen aber nicht dauerhaft sein.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="w-full py-16 px-6 md:px-12" data-id="element-1900">
        <div className="max-w-4xl mx-auto" data-id="element-1901">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1902">
            Einzeltherapie
          </h1>
          <div className="prose prose-lg max-w-none" data-id="element-1903">
            <p className="text-lg text-gray-700 mb-8" data-id="element-1904">
              In meiner Praxis biete ich psychotherapeutische Unterstützung für
              Einzelpersonen nach dem Heilpraktikergesetz an. Mein Ansatz
              basiert auf der kognitiven Verhaltenstherapie und der systemischen
              Therapie sowie meiner langjährigen Erfahrung im Umgang mit
              Menschen in beruflichen und privaten Belastungssituationen.
            </p>
            <p className="text-lg text-gray-700 mb-8" data-id="element-1905">
              Dies ermöglicht mir, fundiert, zielorientiert und zugleich
              individuell auf Ihre Themen einzugehen.
            </p>
            <p className="text-lg text-gray-700 mb-12" data-id="element-1906">
              Es gibt Lebensphasen, in denen innere Klarheit fehlt, der Druck zu
              groß wird oder alte Muster sich wiederholen. Die psychische
              Belastung ist groß, Lebenskrisen brechen über uns herein oder der
              Wunsch nach persönlicher Weiterentwicklung entsteht. In solchen
              Momenten kann psychotherapeutische Begleitung helfen, Orientierung
              zu gewinnen, sich zu entlasten und neue Wege zu finden.
            </p>
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-1907">
              Ich unterstütze Sie – empathisch, strukturiert und
              lösungsorientiert – bei:
            </h2>
            <div className="mb-12" data-id="element-1908">
              <Accordion.Root type="single" collapsible className="space-y-4" data-id="element-1909">
                <AccordionItem value="item-1" title="Niedergeschlagenheit, Erschöpfung oder Burnout" data-id="element-1910">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1911">
                    Mit reduziertem Antrieb, Freude oder Energie wirkt selbst
                    der Alltag wie eine unüberwindbare Hürde. In solchen
                    Momenten kann psychologische Beratung oder Einzeltherapie
                    helfen, erste Entlastung zu finden, Zusammenhänge besser zu
                    verstehen und neue Perspektiven zu entwickeln. Ziel ist es,
                    Ihre psychische Stabilität zu stärken und Wege zurück in die
                    Lebensfreude zu ermöglichen.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-2" title="Ängsten, Sorgen oder anhaltende Grübelgedanken" data-id="element-1912">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1913">
                    Wenn Sorgen überhandnehmen, sich Gedanken endlos im Kreis
                    drehen oder Ängste den Alltag bestimmen, leidet die
                    Lebensqualität spürbar. Gemeinsam betrachten wir Auslöser,
                    Denk- und Verhaltensmuster – und entwickeln konkrete
                    Strategien, um Ängste abzubauen und den inneren Druck zu
                    reduzieren.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-3" title="Stressbedingten Beschwerden und innerer Unruhe" data-id="element-1914">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1915">
                    Stress gehört zum Leben – und wir alle kennen Zeiten, in
                    denen es besonders viel zu tun gibt. Problematisch wird es,
                    wenn Anspannung zum Dauerzustand wird, die Erholung
                    ausbleibt und erste körperliche oder psychische Symptome
                    auftreten: Schlafprobleme, Reizbarkeit,
                    Konzentrationsschwierigkeiten oder innere Unruhe. In der
                    Therapie arbeiten wir daran, Ihre individuellen
                    Stressauslöser zu erkennen, innere Antreiber zu reflektieren
                    und alltagstaugliche Strategien zur Entlastung und
                    Stabilisierung zu entwickeln.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-4" title='Selbstwertproblemen und dem Gefühl, „nicht gut genug" zu sein' data-id="element-1916">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1917">
                    Viele Menschen wissen erstaunlich wenig über ihre eigenen
                    Stärken – stattdessen stehen Selbstkritik, Zweifel und der
                    Vergleich mit anderen im Vordergrund. Ein negatives
                    Selbstbild kann sich über Jahre verfestigen und wirkt oft
                    wie ein leiser innerer Kritiker, der Erfolg und Lebensfreude
                    bremst. In der Therapie nehmen wir diese inneren
                    Überzeugungen gemeinsam unter die Lupe: Was davon gehört
                    wirklich zu Ihnen – und was wurde Ihnen „angelernt"? Ziel
                    ist es, negative Selbstbilder zu hinterfragen und durch
                    realistischere, stärkende Sichtweisen zu ersetzen. Wir
                    arbeiten an mentaler Stärke, fördern Selbstfürsorge im
                    Alltag und stärken so Ihr Vertrauen in sich selbst – Schritt
                    für Schritt.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-5" title="Schwierigkeiten im Umgang mit Emotionen oder im zwischenmenschlichen Kontakt" data-id="element-1918">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1919">
                    Emotionen geben uns Tiefe, Richtung und Verbindung. Doch
                    nicht immer fällt es leicht, Gefühle klar zu erkennen oder
                    angemessen damit umzugehen. Manche Menschen erleben sich als
                    „zu empfindlich", andere spüren kaum, was eigentlich in
                    ihnen vorgeht. In der Therapie schaffen wir Raum, um Ihre
                    emotionalen Prozesse besser zu verstehen: Was fühle ich –
                    und warum? Wie kann ich Gefühle regulieren, statt sie zu
                    unterdrücken oder von ihnen überrollt zu werden? Gemeinsam
                    reflektieren wir Kommunikations- und Beziehungsmuster und
                    stärken Ihre Fähigkeit, sich selbst und anderen authentisch,
                    klar und verbunden zu begegnen.
                  </p>
                </AccordionItem>
                <AccordionItem value="item-6" title="Lebenskrisen und Umbruchsituationen" data-id="element-1920">
                  <p className="text-gray-600 leading-relaxed" data-id="element-1921">
                    Manche Veränderungen kündigen sich an, andere treffen uns
                    plötzlich und ohne Vorwarnung. Eine Trennung, der Verlust
                    eines geliebten Menschen oder tiefgreifende Umbrüche können
                    das Leben aus dem Gleichgewicht bringen – und oft fällt es
                    schwer, in den gewohnten Alltag zurückzufinden. Trauer ist
                    kein linearer Prozess, sondern ein individueller Weg, der
                    Zeit, Raum und Mitgefühl braucht. In der Therapie begleite
                    ich Sie durch diese herausfordernden Phasen – mit Ruhe,
                    Klarheit und dem Blick dafür, was gerade wirklich trägt. Wir
                    sortieren gemeinsam Gedanken und Gefühle, schaffen
                    Entlastung und entwickeln neue Orientierung – behutsam und
                    in Ihrem Tempo.
                  </p>
                </AccordionItem>
              </Accordion.Root>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1922">
              <h2 className="text-2xl font-medium text-gray-700 mb-6" data-id="element-1923">
                Ablauf
              </h2>
              <ul className="space-y-4 text-gray-700" data-id="element-1924">
                <li className="flex items-start" data-id="element-1925">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1926"></div>
                  <span data-id="element-1927">
                    Die Sitzungen finden in einem geschützten Rahmen statt –
                    wertschätzend, transparent und auf Augenhöhe.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1928">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#a1acb1] mr-3 mt-2" data-id="element-1929"></div>
                  <div data-id="element-1930">
                    <p data-id="element-1931">
                      Ich arbeite ausschließlich im privatpsychotherapeutischen
                      Bereich auf Selbstzahlerbasis sowie als Heilpraktikerin
                      für Psychotherapie.
                    </p>
                    <p className="mt-2 font-medium" data-id="element-1932">Bitte beachten Sie:</p>
                    <p className="italic" data-id="element-1933">
                      Die Kosten für Psychotherapie durch Heilpraktiker für
                      Psychotherapie werden von den gesetzlichen Krankenkassen
                      leider nicht übernommen!
                    </p>
                    <p className="mt-2" data-id="element-1934">
                      Falls Sie eine private Krankenversicherung oder eine
                      heilpraktische Zusatzversicherung haben, besteht die
                      Möglichkeit, die Kosten für Psychotherapie nach der
                      Gebührenordnung für Heilpraktiker (GebüH Ziffer 19:
                      Psychotherapie) abzurechnen.
                    </p>
                    <p className="mt-2" data-id="element-1935">
                      Für eine (anteilige) Kostenübernahme ist es notwendig,
                      dass Sie vor Behandlungsbeginn mit Ihrer privaten
                      Krankenkasse abklären, ob eine heilkundliche
                      Psychotherapie bei psychotherapeutischen Heilpraktikern
                      erstattet wird.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="mt-8 text-center" data-id="element-1936">
              <p className="text-gray-600" data-id="element-1937">
                Weitere Informationen zum Ablauf und Honorar finden Sie{' '}
                <a href="/eva_schifferer/info" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1938">
                  hier
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
      <EvaSchiffererFooter data-id="element-1939" />
    </div>;
}
// Accordion Item Component
const AccordionItem = ({
  children,
  value,
  title
}: {
  children?: React.ReactNode;
  value: string;
  title: string;
}) => {
  return <Accordion.Item value={value} className="border-b border-gray-200 overflow-hidden" data-id="element-1940">
      <Accordion.Header data-id="element-1941">
        <Accordion.Trigger className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-1942">
          <span className="text-lg font-medium text-gray-700" data-id="element-1943">{title}</span>
          <ChevronsDownIcon className="h-5 w-5 text-[#c2cde0] transition-transform duration-300 ease-[cubic-bezier(0.87,0,0.13,1)] group-data-[state=open]:rotate-180" data-id="element-1944" />
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content className="overflow-hidden data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-id="element-1945">
        <div className="p-4 bg-white" data-id="element-1946">{children}</div>
      </Accordion.Content>
    </Accordion.Item>;
};